import Swiper from 'swiper/dist/js/swiper.min';
import Axios from 'axios';
import Vue from 'vue';
import CardSlider from '../card/card-slider/card-slider';
import Manager from '../manager/manager';
import PopupFullscreen from '../popup/fullscreen/popup-fullscreen';
import PopupArticle from '../popup/article/popup-article';
import PopupProjectsObject from '../popup/projects-object/popup-projects-object';
import AnimationFade from '../../core/animation/fade/animation-fade';

export default function () {
  const section = document.querySelectorAll('.topProjects');

  if (section && section.length) {
    [].slice.call(section).forEach((item) => {
      const obj = window.topProjects;
      obj.items.forEach((i) => {
        i.isOpened = false;
      });
      new Vue({
        el: item,
        delimiters: ['${', '}}'],
        components: {
          Manager,
          CardSlider,
          PopupFullscreen,
          PopupArticle,
          AnimationFade,
          PopupProjectsObject,
        },
        data() {
          return {
            topProjectsData: obj,
            fullscreenCards: [],
            popupFullOpen: false,
            popupArticleOpen: false,
            popupObjectOpen: false,
            activeCard: 0,
            article: {},
            popupObjectData: {},
          };
        },
        mounted() {
          this.slidersInit();
        },
        methods: {
          slidersInit() {
            this.mainSlider = new Swiper(this.$el.querySelector('.topProjects__slider .swiper-container'), {
              slidesPerView: 3,
              spaceBetween: 20,
              navigation: {
                nextEl: this.$el.querySelector('.sliderButtons__btn--next'),
                prevEl: this.$el.querySelector('.sliderButtons__btn--prev'),
              },
              breakpoints: {
                1023: {
                  slidesPerView: 2,
                  spaceBetween: 21,
                },
                767: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
              },
            });
          },
          openFullPopup(data) {
            const popup = this.$el.querySelector('.popup-fullscreen');
            this.fullscreenCards = data.cards;
            this.activeCard = data.active;
            window.bodyLock.disableBodyScroll(popup);
            setTimeout(() => {
              this.popupFullOpen = true;
            }, 500);
          },
          openArticlePopup(i) {
            const popupArticle = this.$el.querySelector('.popup-article');
            this.article = obj.items[i];
            window.bodyLock.disableBodyScroll(popupArticle);
            setTimeout(() => {
              this.popupArticleOpen = true;
            }, 500);
          },
          openCardPopup(object) {
            if (object.id && object.popupApi) {
              Axios.get(object.popupApi, {
                params: {
                  id: object.id,
                },
              }).then((response) => {
                this.popupObjectData = response.data;
                this.popupObjectOpen = true;
              }).catch((error) => {
                throw new Error(error);
              });
            } else if (object.popupData) {
              this.popupObjectData = object.popupData;
              this.popupObjectOpen = true;
            }
          },
          closeCardPopup() {
            this.popupObjectData = {};
            this.popupObjectOpen = false;
            window.bodyLock.clearAllBodyScrollLocks();
          },
          showChats(object) {
            object.isOpened = true;
          },
        },
      });
    });
  }
}



// WEBPACK FOOTER //
// ./new-blocks/topProjects/topProjects.js